<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}"
            *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->



 

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}"
                            *ngIf="showNavComponent"></app-plugin-navbar>
                    </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between">
                                        <h2 class="screen-reader">{{ 'WarehouseAssessment' | translate}}</h2>

<!-- 
                                        <a routerLink="/archivtender"
                                            class="btn btn-sm btn-outline-success screen-reader"><i
                                                class="bi bi-archive me-2"></i>{{ 'ArchiveTenders' | translate}}</a> -->
                                    </div>
                                    <div class="description">
                                        <div class="tenders">
                                            <div class="row">
                                                <div class="col-lg-12" >
                                                
                                                    <div class="table-responsive  font-adjust">
                                                    <table class="table">
                                                       <thead>
                                                        <tr>
                                                            <th class="screen-reader tblbdt" scope="col">{{ "Parameters" | translate }}</th>
                                                            <th class="screen-reader tblbdt" scope="col">{{ "SumofParameter" | translate }}</th>
                                                            <th class="screen-reader tblbdt" scope="col">{{ "PercentageNew" | translate }}</th>
                                                            <th class="screen-reader tblbdt" scope="col">{{ "SubParameters" | translate}}</th>
                                                            <th class="screen-reader tblbdt" scope="col">{{ "SumofScore" | translate}}</th>
                                                            <th class="screen-reader tblbdt" scope="col">{{ "PercentageNew" | translate }}</th>
                                                        </tr>
                                                       </thead>
                                                       <!-- <tbody>
                                                        <tr *ngFor="let item of tenderList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords}; let i = index;">
                                                            <td class="screen-reader">{{ item.suggested_parameters_name }}</td>
                                                            <td class="screen-reader">{{ item.sum_of_parameter }}</td>
                                                            <td class="screen-reader">{{ item.sum_of_parameter_percent }}</td>
                                                            <td class="screen-reader">{{ item.suggested_sub_parameters_name }}</td>
                                                            <td class="screen-reader">{{ item.sum_of_sub_parameter }}</td>
                                                            <td class="screen-reader">{{ item.sum_of_sub_parameter_percent }}</td>
                                                        </tr>
                                                       </tbody> -->
                                                       <tbody>
                                                        <ng-container *ngIf="table_body.length > 0;">
                                                          <ng-container *ngFor="let listItems of table_body | paginate : {
                                                            itemsPerPage: limit,
                                                            currentPage: currentPage,
                                                            totalItems: totalRecords,
                                                            id:'pg1'
                                                          }; let i=index;">
                                                          
                                                            <tr>
                                                            
                                                              <td [attr.rowspan]="listItems.total_sub_category" class="tblbdt" style=" text-align: center; vertical-align: middle; ">
                                                                {{ listItems.suggested_parameters_name }}
                                                              </td>
                                                              <td [attr.rowspan]="listItems.total_sub_category" class="tblbdt"  style=" text-align: center; vertical-align: middle; ">
                                                                {{ listItems.sum_of_parameter }}
                                                              </td>
                                                              <td [attr.rowspan]="listItems.total_sub_category" class="tblbdt"  style=" text-align: center; vertical-align: middle; ">
                                                                {{ listItems.sum_of_parameter_percent }}
                                                            </td>
                                                            <td class="tblbdt" > 
                                                            {{ listItems.sub_category.length > 0?  
                                                                listItems.sub_category[0].suggested_sub_parameters_name 
                                                                : '' }}
                                                            </td>
                                                            <td class="tblbdt" >
                                                            {{ listItems.sub_category.length > 0?  
                                                                listItems.sub_category[0].sum_of_sub_parameter 
                                                                : '' }}
                                                            </td >
                                                            <td class="tblbdt" >
                                                            {{ listItems.sub_category.length > 0?  
                                                                listItems.sub_category[0].sum_of_sub_parameter_percent 
                                                                : '' }}
                                                            </td>
                                                            </tr>
                                                            <ng-container *ngFor="let listItem of listItems.sub_category; let j = index">
                                                              <tr *ngIf="j > 0">
                                                                <td class="tblbdt" >{{ listItem.suggested_sub_parameters_name }}</td>
                                                                <td class="tblbdt" >{{ listItem.sum_of_sub_parameter }}</td>
                                                                <td class="tblbdt" >{{ listItem.sum_of_sub_parameter_percent }}</td>
                                                              </tr>
                                                            </ng-container>
                                                          </ng-container>
                                                        </ng-container>
                                                      </tbody>
                                                       <tfoot>
                                                        <tr>
                                                            <th class="screen-reader tblbdt">Total</th>
                                                            <th class="screen-reader tblbdt">{{ footerdata.total_sum_of_parameter }}</th>
                                                            <th class="screen-reader tblbdt">{{ footerdata.total_sum_of_parameter_percent }}%</th>
                                                            <th class="screen-reader tblbdt">Total</th>
                                                            <th class="screen-reader tblbdt">{{ footerdata.total_sum_of_sub_parameter }}</th>
                                                            <th class="screen-reader tblbdt">{{ footerdata.total_sum_of_sub_parameter_percent }}%</th>
                                                        </tr>
                                                       </tfoot>
                                                    </table>
                                                </div>
                                                    <pagination-controls id="pg1" class="text-center screen-reader"
                                                        (pageChange)="pageChanged($event)"
                                                        *ngIf="totalRecords > limit"></pagination-controls>
 </div>                                                
                                                </div>
 

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
  

</section>

<app-clients></app-clients>

<app-footer></app-footer>